import React, { useState } from "react";
import Footer from "../Footer";
import Sidebar from "../sidebar";
import Topnav from "../TopNav";

const About = () => {
    const [show, setShow] = useState(false);

    const toggleSidebar = () => {
        setShow(prevShow => !prevShow);
    };

    return (
        <html lang="en">
            <body>
                <div className="wrapper">
                    <Sidebar show={show} />
                    <div className="main-panel">
                        <Topnav toggleSidebar={toggleSidebar} />
                        <div className="container">
                            <div className="page-inner">
                                <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                                    <h4 className="fw-bold mb-3" style={{ fontSize: '18px' }}>E-books Author Dashboard</h4>
                                </div>
                                <p style={{ textAlign: 'left' }}>
                                    This dashboard allows authors to track their book sales, revenue, and manage withdrawals.
                                    <br /><br />
                                    <strong>Features:</strong><br />
                                    • View total sales and revenue<br />
                                    • Monitor pending and cleared payouts<br />
                                    • Request withdrawals (minimum $35)<br />
                                    • View purchase history<br />
                                    <br />
                                    Withdrawals are processed manually by the admin and cleared within 48 hours.
                                </p>
                            </div>
                        </div>
                        <footer className="footer">
                            <Footer />
                        </footer>
                    </div>
                </div>
            </body>
        </html>
    );
};

export default About;